import wavemill0 from '../../assets/wavemill0.jpg'
import wavemill1 from '../../assets/wavemill1.png'
import app2 from '../../assets/app2.jpg'
import app3 from '../../assets/app3.jpg'
import app4 from '../../assets/app4.jpg'
import app5 from '../../assets/app5.jpg'

export default function TabWm() {

    const myheader1 = {
      color: "white",
      textAlign: 'center',
      fontFamily: 'Calibri',
    };

    const myheader2 = {
      color: "white",
      textAlign: 'center',
      fontFamily: 'Calibri',
      fontStyle: 'italic'
    };    

  return (
  <div>
     <div style={{minHeight: '28vh',height: 'auto', backgroundPosition: 'center', backgroundImage: "url(" + wavemill0 + ")", backgroundRepeat: 'no-repeat', backgroundSize: '900px 600px'}}>
      <br /> 
      <h2 style={myheader1}>INVESTMENT OPPORTUNITY</h2>
      <h3 style={myheader2}>“…the world’s leading wave energy converter…”</h3>             
    </div>   

    <h3 className='align_center'> Solving the challenge of achieving net zero by harnessing the energy of the world’s oceans </h3> 

    <p className='align_left'>

      The only Wave Energy Converter (WEC) capable of generating commercially viable power. <br />
      <br />
      Wave Mill is an advanced ocean wave energy converter designed to generate reliable renewable power with minimal mechanical complexity. The system operates quietly and contains no moving mechanical parts, significantly reducing maintenance requirements and improving long-term reliability in harsh marine environments. <br />
      <br />

      The Wave Mill is designed as a large floating offshore facility with a multifunctional deck capable of supporting a wide range of commercial and infrastructure applications. <br />
      <br />

      <b>Patented technology that:</b>
      <br />
      <ul>
      <li> delivers a competitive LCOE  </li>
      <li> has a  25-year guaranteed operating life </li>
      <li> is simple in design, reducing CAPEX and OPEX costs </li>
      <li> is suitable for both nearshore and offshore  applications </li>
      <li> can generate power across a wide range of weather and wave conditions.</li>
      <li> can be utilized as a dual-fuel renewable energy source.</li>
      </ul>
      <br />
      Ocean power market projected to reach US$7.8bn by 2031 (CAGR of 21%).
      <br />
      
      Global applications, with the world’s oceans representing a 30,000 TWh untapped energy source.   <br />
      Current projects in the pipeline valued at over A$100M.    <br />
      Clear opportunity for Wave Power Engineering (WPE) to take a market-leading position. <br />
      <br />

    </p>

    <h3 className='align_center'>The Wave Mill applications</h3>                
    
   
    <p className='align_left'>      

    For customers, the Wave Mill is a large floating platform with an embedded power supply.<br />
    <br />
    Generated power can be used onboard or transmitted to the land grid.<br />
    
    <br />

     <div style={{minHeight: '300px', maxHeight: '300px', backgroundPosition: 'center', backgroundImage: "url(" + wavemill1 + ")", backgroundRepeat: 'no-repeat', backgroundSize: '900px 600px'}}>

     </div>
    {/* <img src={wavemill1} style={{marginLeft:"10px", objectFit: 'fill' }} alt='' /> */}

    <br /><br />
    The large and spacious deck is completely open for customer applications.<br />
<br />
      Wave Mill is designed as a multi-purpose offshore infrastructure platform, <br />
      enabling multiple revenue streams and flexible deployment strategies.  <br />

      <br />
      <b>Wave Mill applications include: </b>

      <ul>
      <li>Power supply for islands and nearshore communities</li>
      <li>Floating foundation for other renewables and green hydrogen production</li>
      <li>Floating support facilities for the offshore industry</li>
      <li>Mariculture (fish cages, oyster farms)</li>
      <li>Floating breakwaters and marinas</li>
      <li>Coastal protection</li>
      <li>Tourism and recreation (artificial reefs, diving platforms, boatels)</li>
      </ul>
    </p>
       
      	                 
   



    <br />              
    <div class="container" style={{flexWrap: 'wrap', gap: '1rem'}}>       
      <div>     
        <img src={app2} style={{height: '14vw', height: 'auto', objectFit: 'fill' }} alt='' />	
        <br /> Power supply for islands and nearshore communities                
      </div>  
      <div>     
        <img src={app4} style={{height: '14vw', height: 'auto', objectFit: 'fill' }} alt='' />	  
        <br /> Tourism and recreation (artificial reef, diving platforms, boatels)              
      </div>                                                        
    </div>       
    <br /> 
    <div class="container" style={{flexWrap: 'wrap', gap: '1rem'}}>         
      <div>                
        <img src={app3} style={{height: '14vw', height: 'auto', objectFit: 'fill' }} alt=''/>   
        <br /> Floating breakwater and marina       
      </div>                       
      <div>                
        <img src={app5} style={{height: '14vw', height: 'auto', objectFit: 'fill' }} alt=''/> 
        <br /> Mariculture (Fish cages, oyster farms)         
      </div>                       
    </div> 
 
  </div>  

  )
}
